<template>
  <div class="VR__container">
    <header-wrap></header-wrap>
    <div class="vr-box">
      <iframe :src="vrSrc" frameborder="no" width="100%" height="100%" v-if="vrSrc"></iframe>
    </div>
  </div>
</template>

<script>
import { getConfigDataApi } from "@/utils/http.js";


export default {
  data() {
    return {
      vrSrc: ''
    }
  },

  created() {
    this.fetchConfigData()
  },

  methods: {
    fetchConfigData() {
      getConfigDataApi().then(result => {
        if (result.code == 1) {
          this.vrSrc = result.data.vr_link
        }
      })
    },
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
.VR__container {
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
}

.vr-box {
  flex: 1;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/VR/index.vue